module.exports = __webpack_public_path__ + "files/SPIADI2024 - Présentation SRLF.a1e962d1f8f560e1d0e1d443ea7e0cd7.pdf";